import React from "react";
import { Container, Paper, makeStyles } from "@material-ui/core";
import LoadingBackdrop from "../../shared/components/LoadingBackdrop";
import BreadcrumbsSection from "../../shared/components/BreadcrumbsSection";
import PageHeader from "../../shared/components/PageHeader";

import { Formik, Form } from "formik";
import { RegularRouteFormValues } from "./components/interfaces";
import RegularRouteForm, {
  getRegularRouteFormInitialValues,
  getRegularRouteFormValidationSchema
} from "./components/RegularRouteForm";
import useUrlQuery from "../../shared/hooks/useUrlQuery";
import { useCreateUpdateRegularRoute } from "../../apollo/serviceRoutes/mutations";
import {
  RegularServiceRoute,
  ServiceRoute
} from "../../apollo/serviceRoutes/interfaces";
import { ApolloError } from "@apollo/client";
import useSnackbar from "../../shared/hooks/useSnackbar";
import { useHistory, useParams } from "react-router-dom";

const useStyles = makeStyles(theme => ({
  paperContainer: {
    padding: theme.spacing(3, 0)
  }
}));

const useRegularRouteFormPage = () => {
  const { sendErrorMessage, sendSuccessMessage } = useSnackbar();
  const history = useHistory();
  const { routeId } = useParams<{ routeId: string }>();
  const isEdit = !!routeId;
  const onSubmitSuccess = (route: ServiceRoute) => {
    sendSuccessMessage(
      `Service Route ${isEdit ? "updated" : "created"} successfully.`
    );
    history.push("/dashboard/serviceRoutes/" + route.id);
  };

  const onSubmitError = (error: ApolloError) => {
    sendErrorMessage(
      `Something went wrong trying to ${
        isEdit ? "updated" : "created"
      } the service route.`
    );
    console.warn(error);
  };

  const { submitRoute, createRouteLoading } = useCreateUpdateRegularRoute(
    isEdit,
    onSubmitSuccess,
    onSubmitError
  );

  const onFormSubmit = (values: RegularRouteFormValues) => {
    const { property, ...rest } = values;
    submitRoute({
      variables: {
        route: rest
      }
    });
  };

  return {
    model: { isSubmitting: createRouteLoading, isEdit },
    commands: {
      onFormSubmit
    }
  };
};
const RegularRouteFormPage: React.FC = () => {
  const {
    model: { isSubmitting, isEdit },
    commands: { onFormSubmit }
  } = useRegularRouteFormPage();

  const classes = useStyles();
  return (
    <Container>
      <LoadingBackdrop open={isSubmitting} />
      <BreadcrumbsSection
        sections={[
          { label: "Home", link: "/dashboard" },
          { label: "Service Routes", link: "/dashboard/serviceRoutes" },
          { label: "Service Route Form" }
        ]}
      />
      <PageHeader
        title={isEdit ? "Update Service Route" : "Create Service Route"}
      />
      <Paper className={classes.paperContainer}>
        <Container>
          <Formik
            initialValues={getRegularRouteFormInitialValues()}
            onSubmit={onFormSubmit}
            validateOnMount={false}
            validateOnChange={false}
            validationSchema={getRegularRouteFormValidationSchema()}
          >
            <Form>
              <RegularRouteForm />
            </Form>
          </Formik>
        </Container>
      </Paper>
    </Container>
  );
};

export default RegularRouteFormPage;
